/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Component,
  ElementRef,
  forwardRef,
  Input,
  EventEmitter,
  Output,
  ViewChild
} from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'm-input-search',
  templateUrl: './m-input-search.component.html',
  styleUrls: ['./m-input-search.component.scss'],
  imports: [FormsModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MInputSearchComponent),
      multi: true
    }
  ]
})
export class MInputSearchComponent {
  @Input() value: any = '';
  @Output() inputBlur: EventEmitter<void> = new EventEmitter<void>();
  @Input() placeholder = '';
  @Input() disabled = false;

  @ViewChild('searchInput') searchInput?: ElementRef<HTMLInputElement>;

  onChange: any = () => {};
  onTouched: any = () => {};

  focus(): void {
    this.searchInput?.nativeElement?.focus();
  }

  onBlur(): void {
    this.onTouched();
    this.inputBlur.emit();
  }

  onValueChange(newValue: any): void {
    this.value = newValue;
    this.onChange(newValue);
  }

  clearInput(): void {
    this.onValueChange('');
  }

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
